import React from 'react';
import css from './Tables.module.css';
import arrowUp from '../../../assets/ArrowUpBlue.svg';
import arrowDown from '../../../assets/ArrowDownBlue.svg';

const TableHead = ({ headers, onChangeSort, sortKey, sortOrder }) => {
  return (
    <tr>
      {headers?.map(header => {
        const isCurrentSortKey = sortKey === header.key;
        return (
          <th
            key={header.key}
            className={header.className || css.th}
            style={{
              cursor: 'pointer',
              color: isCurrentSortKey ? '#2055FD' : '#111A39',
              ...header.style,
            }}
            onClick={() => onChangeSort(header.key, header.type)}
          >
            {header.key ? (
              <div className={css.headerSort}>
                <div style={{ whiteSpace: 'nowrap' }}>
                  {header.label}
                  {isCurrentSortKey && (
                    <img
                      className={css.imgIcon}
                      alt={sortOrder === 'asc' ? 'arrow up' : 'arrow down'}
                      src={sortOrder === 'asc' ? arrowUp : arrowDown}
                    />
                  )}
                </div>
              </div>
            ) : (
              header.label
            )}
          </th>
        );
      })}
    </tr>
  );
};

export default TableHead;
